<template lang="pug">
section
  v-toolbar(flat color='white')
    h2(class='title') Архив ролей
  v-divider
  v-data-table(
    :loading='isLoading'
    :headers='headers'
    :items='list'
    :total-items='total'
    :pagination.sync='pagination'
    :rows-per-page-items='$config.rowsPerPageItems'
  )
    template(slot='items' slot-scope='props')
      td {{ props.item.id }}
      td {{ props.item.role_name }}
      td {{ props.item.sites }}
      td {{ props.item.start_time }}
      td {{ props.item.finish_time }}
</template>

<script>
import http from '@/http'

export default {
  props: ['userId'],

  data: () => ({
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '0%',
        sortable: false
      },
      {
        text: 'Название роли',
        align: 'left',
        value: 'role_name',
        width: '33%',
        sortable: false
      },
      {
        text: 'Для сайтов',
        align: 'left',
        value: 'sites',
        width: '33%',
        sortable: false
      },
      {
        text: 'Дата начала действия',
        align: 'left',
        value: 'start_time',
        width: '33%',
        sortable: false
      },
      {
        text: 'Дата окончания действия',
        align: 'left',
        value: 'finish_time',
        width: '33%',
        sortable: false
      }
    ],
    pagination: {
      page: 1
    },
    isLoading: false,
    total: 0,
    list: []
  }),

  created() {
    this.fetch()
  },

  methods: {
    async fetch() {
      if (!this.userId) return

      this.isLoading = true

      try {
        let { data } = await http.get(`/admin/users/${this.userId}/roles/old`, {
          params: this.pagination
        })
        this.list = data.data
        this.total = data.total
      } catch (e) {
        this.$root.showSnack('Не удалось загрузить архив ролей')
      }

      this.isLoading = false
    }
  },

  watch: {
    pagination: {
      deep: true,
      handler: 'fetch'
    }
  }
}
</script>
